import { css } from 'styled-components';

export const Styles = css`
	h1,
	h2,
	h3,
	p {
		color: #333333;
	}

	h1,
	h2,
	h3 {
		font-weight: bold;
	}

	h1 {
		font-size: 3.6rem;

	h2 {
		font-size: 2.8rem;
	}

	h3 {
		font-size: 2rem;
	}

	p {
		font-size: 1.6rem;
	}

	html {
		background-color: #FFFFFF;
	}
`;
